import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { ServiceStatusConstant } from './constants/ServiceStatusConstant';
import { AlertAction } from './AlertAction';

const GetStatus = () => async (dispatch, getState) => {
	const { lastUpdated } = getState().ServiceStatusReducer;
	if (!lastUpdated) {
		dispatch({ type: ServiceStatusConstant.LOADING });
	}
	try {
		const data = { type: 'getStatus' };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/servicestatus', data, JWT());
		if (ret.data.status === 'success') {
			dispatch({ type: ServiceStatusConstant.GET_STATUS_SUCCESS, payload: ret.data.data });
		} else {
			dispatch({ type: ServiceStatusConstant.GET_STATUS_FAIL });
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch({ type: ServiceStatusConstant.GET_STATUS_FAIL });
	}
	if (!lastUpdated) {
		dispatch({ type: ServiceStatusConstant.LOADED });
	}
};

const GetCounts = () => async (dispatch) => {
	try {
		const data = { type: 'getCounts' };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/servicestatus', data, JWT());
		if (ret.data.status === 'success') {
			dispatch({ type: ServiceStatusConstant.GET_COUNTS_SUCCESS, payload: ret.data.data });
		} else {
			dispatch({ type: ServiceStatusConstant.GET_COUNTS_FAIL });
		}
	} catch (error) {
		dispatch({ type: ServiceStatusConstant.GET_COUNTS_FAIL });
	}
};

const SetEnabled = (companyId, enabled) => async (dispatch) => {
	dispatch({ type: ServiceStatusConstant.LOADING });
	try {
		const data = { type: 'setEnabled', data: { companyId, enabled } };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/servicestatus', data, JWT());
		if (ret.data.status === 'success') {
			dispatch({ type: ServiceStatusConstant.SET_ENABLED_SUCCESS, payload: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceStatusConstant.LOADED });
};

export const ServiceStatusAction = {
	GetStatus,
	GetCounts,
	SetEnabled,
};
